import { IProfessional } from "../../types";
import { DetailsItem } from "./detail-item";

interface ProfessionalDetailsProps {
  professional: IProfessional;
}

const ProfessionalDetails = ({ professional }: ProfessionalDetailsProps) => {
  return (
    <div className="border shadow-sm p-6 rounded-lg">
      <p className="text-xl mb-2">Professional Details</p>
      <div className="flex flex-col space-y-2">
        <DetailsItem
          label="Years of Experience"
          value={professional?.yearsOfExperience || ""}
          disabled
        />
        <DetailsItem
          label="Portfolio Link"
          value={professional?.portfolio || ""}
          disabled
        />
        <DetailsItem
          label="Qualification"
          value={professional?.qualification || ""}
          disabled
        />
        <DetailsItem
          label="C.V"
          value={
            professional?.cv ? (
              <a
                href={professional?.cv}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline"
              >
                View CV
              </a>
            ) : (
              "Not Provided"
            )
          }
          disabled
        />
      </div>
    </div>
  );
};

export default ProfessionalDetails;
